// extracted by mini-css-extract-plugin
module.exports = {"c1yrx6jy":"c1yrx6jy"};